import type { AuthenticatedUser, MembershipSummary } from '@livechat/shared';

interface TenantPreferenceStorage {
	getItem(key: string): string | null;
}

export function activeMemberships(user: AuthenticatedUser): MembershipSummary[] {
	return user.memberships.filter((membership) => membership.status === 'active');
}

export function lastTenantKey(userId: string): string {
	return `livechat:last-tenant:${userId}`;
}

export function preferredTenant(
	user: AuthenticatedUser,
	storage: TenantPreferenceStorage = localStorage,
): string | undefined {
	const memberships = activeMemberships(user);
	const saved = storage.getItem(lastTenantKey(user.id));
	if (saved && memberships.some((membership) => membership.tenantId === saved)) {
		return saved;
	}
	return memberships.length === 1 ? memberships[0]?.tenantId : undefined;
}
